import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SortableHead from '../common/list/SortableHead';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class ContactPersonListTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            contactPersons,
            onClone,
            onDelete,
            listId,
            companyId,
            intl
        } = this.props;

        return (
            <table className="table table-striped">
                <SortableHead
                    listId={listId}
                    action={contactPersonListActions.loadContactPersons}
                    actionParams={[
                        companyId
                    ]}
                    columns={[
                        {
                            title: '#',
                            name: 'id',
                        },
                        {
                            title: 'Titel',
                            name: intl.formatMessage(messages.contactPersonListColumnWorkingTitle),
                        },
                        {
                            title: 'Navn',
                            name: intl.formatMessage(messages.contactPersonListColumnTitleName),
                        },
                        {
                            title: 'E-mail',
                            name: intl.formatMessage(messages.listColumnTitleEmail),
                        },
                        {
                            title: intl.formatMessage(messages.listColumnTitlePhone),
                            name: 'phone',
                        },
                        {
                            title: intl.formatMessage(messages.listColumnTitleOptions),
                            className: 'text-right'
                        },
                    ]}
                />
                <tbody>
                {
                    contactPersons.map(person => {
                        return <tr key={person.id}>
                            <td scope="row" className="align-middle">{person.id}</td>
                            <td className="align-middle">{person.workingTitle}</td>
                            <td className="align-middle">{person.name}</td>
                            <td className="align-middle">{person.email}</td>
                            <td className="align-middle">{person.phone}</td>
                            <td className="list-actions text-right align-middle">

                                <div className="btn-group text-right">
                                    <Link
                                        to={`/kontaktperson/redigere/${person.id}`}
                                        title={intl.formatMessage(messages.listDropDownButtonEdit)}
                                        className="btn btn-secondary waves-effect list-action"
                                    >
                                        <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                                    </button>
                                    <div className="dropdown-menu">
                                        <button
                                            title={intl.formatMessage(messages.listDropDownButtonClone)}
                                            type="button"
                                            className="dropdown-item clickable"
                                            onClick={() => onClone(person.id)}
                                        >
                                            <i className="fa fa-clone"/> {intl.formatMessage(messages.listDropDownButtonClone)}
                                        </button>
                                        <div className="dropdown-divider"/>
                                        <button type="button"
                                                className="dropdown-item clickable"
                                                onClick={() => onDelete(person.id)}
                                        >
                                            <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                                        </button>
                                    </div>
                                </div>

                            </td>
                        </tr>
                    })
                }
                </tbody>
            </table>
        )
    }
}

export default injectIntl(ContactPersonListTable);




// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonListTable.jsx